import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteHandlerService } from '../../services/route-handler.service';

@Component({
  selector: 'app-inicial',
  templateUrl: './inicial.component.html',
  styleUrls: ['./inicial.component.scss']
})
export class InicialComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private routeHandler: RouteHandlerService) {
    console.log('asd')
    this.route.queryParams.subscribe(params => {      
      this.routeHandler.navegar(params);
    });
  }

  ngOnInit(): void {
  }

  navegarNotaFiscal(): void {
    this.router.navigate(['issqn/nota-fiscal']);
  }
}